if (cfg.page === 'products.index') {

	jQuery($ => // allow to sort products
    $('.sortable-container').sortable({
        axis: 'yx',
        containment: 'parent',
        tolerance: 'pointer',
        cursor: 'move',
        items: '.sortable-item',
        cursor: 'move',
        delay: 100,
        update(event, ui) {
            return $.ajax({
                url: '/products/update-order',
                type: 'POST',
                authenticity_token: $('meta[name=csrf-token]').attr('content'),
                data: $('.sortable-container').sortable('serialize')
            });
        }
    }));
}

if ((cfg.page === 'products.new') || (cfg.page === 'products.edit') || (cfg.page === 'products.create')) {

	jQuery(function($) {

		// delete product attachment
		$('.js-destroy-product-attachment').bind('ajax:success', function() {
			return $(this).parents('.thumbnail').remove();
		});

		// urlify product title
		$('.js-product-title').on('keyup', function() {
			if (!$('.js-product-slug').attr('disabled')) {
				const slug = urlify($(this).val());
				return $('.js-product-slug').val(slug);
			}
		});

		// allow to edit product slug
		$('.js-edit-slug').on('click', () => $('.js-product-slug').attr('disabled', false));
			
		// allow to sort products attachments
		return $('.sortable-container').sortable({
			axis: 'yx',
			containment: 'parent',
			tolerance: 'pointer',
			cursor: 'move',
			items: '.sortable-item',
			cursor: 'move',
			delay: 100,
			update(event, ui) {
				return $.ajax({
					url: '/product-attachments/update-order',
					type: 'POST',
					authenticity_token: $('meta[name=csrf-token]').attr('content'),
					data: $('.sortable-container').sortable('serialize')
				});
			}
		});
	});
}
